import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'store'

import { click } from 'utils/tracker'
import { getShowLoginPromptModal } from 'models/ui/selectors'
import { requestLoginPage as requestLoginPageAction } from 'models/user/actions'

import LoginPromptModal from 'components/accountAccess/LoginPromptModal'
import { showLoginPromptModal } from 'models/ui/actions'

interface LoginPromptModalContainerProps {
    isOpen: boolean
    showModal: typeof showLoginPromptModal
    requestLoginPage: typeof requestLoginPageAction
}

const LoginPromptModalContainer = ({ isOpen, showModal, requestLoginPage }: LoginPromptModalContainerProps) => {
    const onClose = useCallback(() => {
        click('DecorateRoom.SignupLogin.OverlayCancel')
        showModal(false)
    }, [showModal])
    const onLogin = useCallback(() => requestLoginPage(), [requestLoginPage])
    const onSignup = useCallback(() => requestLoginPage(true), [requestLoginPage])

    if (!isOpen) {
        return null
    }

    return <LoginPromptModal onClose={onClose} onLogin={onLogin} onSignup={onSignup} />
}

const mapStateToProps = (state: RootState) => ({
    isOpen: getShowLoginPromptModal(state),
})

const mapDispatchToProps = {
    showModal: showLoginPromptModal,
    requestLoginPage: requestLoginPageAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPromptModalContainer)
